import React, { Component } from 'react';
import classNames from 'classnames';

const Footer = () => (
  <div className="footer">
    <div className="footer__copy">
      <small>by</small>{' '}
      <a href="http://www.ondrejmusil.cz" target="_blank">
        Ondřej Musil
      </a>{' '}
      &#9825; <a href="http://www.kacamikesova.cz/">Kateřina Mikešová</a>
    </div>
  </div>
);

export default Footer;



// WEBPACK FOOTER //
// ./src/components/Footer.js